/**
 * Two-column layout for a question asked of both people. Couples answer inline
 * — one screen, side by side — rather than being marched through a separate
 * "now your spouse" pass.
 *
 * Defined at module scope on purpose: an inline component would be a new type
 * every render, forcing React to remount the row and drop field state mid-edit.
 */
import type { ReactNode } from 'react';

export function PersonRow({
  spouseOn, youName, spouseName, children,
}: {
  spouseOn: boolean;
  youName?: string;
  spouseName?: string;
  children: (who: 'you' | 'spouse') => ReactNode;
}) {
  return (
    <div className="wizard-person-row">
      <div>
        {spouseOn && <div className="wizard-who">{youName || 'You'}</div>}
        {children('you')}
      </div>
      {spouseOn && (
        <div>
          <div className="wizard-who">{spouseName || 'Spouse'}</div>
          {children('spouse')}
        </div>
      )}
    </div>
  );
}
